/* BOOTY: theme UX only. Shopify's non-combinable BXGY discount remains authoritative. */
(() => {
  const configNode = document.getElementById('BootyConfig');
  if (!configNode || !window.BootyRules) return;
  const config = JSON.parse(configNode.textContent);
  if (!config.enabled && !config.demo) return;
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: config.currency }).format(cents / 100);
  const clone = object => JSON.parse(JSON.stringify(object));
  class ShopifyCart {
    async request(path, body) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart${path}.js`, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: {'Content-Type':'application/json','Accept':'application/json'}, ...(body ? {body:JSON.stringify(body)} : {}) });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || 'Please try again. Your gift has not been confirmed.');
      return data;
    }
    get() { return this.request(''); }
    update(body) { return this.request('/update', body); }
    add(id) { return this.request('/add', {items:[{id:Number(id),quantity:1}]}); }
    async refresh() {
      const sections = ['mini-cart','cart-icon-bubble','mobile-cart-icon-bubble',document.querySelector('#main-cart-items')?.dataset.id,document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean);
      const cart = await this.update({sections,sections_url:location.pathname});
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'booty-picker',cart});
      return cart;
    }
  }
  class DemoCart {
    constructor() { this.cart = {currency:'USD', items:[{id:1,variant_id:1,key:'merchandise',quantity:1,original_line_price:12900,final_line_price:12900,line_level_discount_allocations:[]}],discount_codes:[],cart_level_discount_applications:[]}; }
    recalc() {
      const state = BootyRules.inspect(this.cart,config);
      const requested = this.cart.discount_codes.map(d=>d.code);
      const booty = requested.includes('BOOTY') && state.qualifies && state.giftCount === 1;
      const wheel = !booty && requested.includes('SPINNYWHEEL10');
      this.cart.discount_codes = requested.map(code=>({code,applicable:code==='BOOTY'?booty:code==='SPINNYWHEEL10'?wheel:false}));
      this.cart.cart_level_discount_applications = wheel ? [{title:'SPINNYWHEEL10',type:'discount_code'}] : [];
      for(const item of this.cart.items) {
        const gift = config.variants.some(v=>String(v.id)===String(item.variant_id));
        item.final_line_price = gift && booty ? 0 : wheel ? Math.round(item.original_line_price*.9) : item.original_line_price;
        item.line_level_discount_allocations = gift && booty ? [{discount_application:{title:'BOOTY',type:'discount_code'},amount:item.original_line_price}] : [];
      }
      this.cart.item_count=this.cart.items.reduce((s,i)=>s+i.quantity,0);
      return clone(this.cart);
    }
    async get() { return this.recalc(); }
    async update(body) {
      if(body.updates) this.cart.items=this.cart.items.filter(i=>body.updates[i.key]!==0);
      if(Object.hasOwn(body,'discount')) this.cart.discount_codes=body.discount.split(',').filter(Boolean).map(code=>({code:BootyRules.normalize(code),applicable:false}));
      return this.recalc();
    }
    async add(id) { this.cart.items.push({id:Number(id),variant_id:Number(id),key:`gift-${id}`,quantity:1,original_line_price:12900,final_line_price:12900,line_level_discount_allocations:[]});return this.recalc(); }
    async refresh() { return this.get(); }
    setSubtotal(cents) { this.cart.items[0].original_line_price=cents; }
  }
  class Controller {
    constructor(adapter) { this.adapter=adapter;this.intent=false;this.message='';this.busy=false;this.cart=null;this.conflict=null;this.idleWaiters=[]; }
    async run(action) {
      // Customer actions wait for an in-flight cart read instead of being discarded.
      while(this.busy)await new Promise(resolve=>this.idleWaiters.push(resolve));
      this.busy=true;this.render();
      try { await action(); } catch(error) { this.message=error.message || 'Please try again before checking out.'; }
      finally { this.busy=false;this.render();this.idleWaiters.splice(0).forEach(resolve=>resolve()); if(this.pending) {this.pending=false;queueMicrotask(()=>this.reconcile());} }
    }
    async removeGifts(cart,discount) {
      const gifts=BootyRules.inspect(cart,config).gifts;
      const body=gifts.length?{updates:Object.fromEntries(gifts.map(i=>[i.key,0]))}:{};
      if(discount!==undefined) body.discount=discount;
      if(Object.keys(body).length)await this.adapter.update(body);
    }
    async apply(code) {
      code=BootyRules.normalize(code);
      if(!code) return;
      await this.run(async()=>{
        this.cart=await this.adapter.get();
        const state=BootyRules.inspect(this.cart,config);
        if(code==='BOOTY') {
          this.intent=true;this.conflict=null;
          this.message=state.otherDiscount?'Choosing a bag replaces your other discount. BOOTY cannot be combined with other offers.':'';
        } else if(state.gifts.length) {
          this.conflict=code;this.message='Choose one offer: keep your free bag or remove it and use your other code.';
        } else { this.cart=await this.adapter.update({discount:code});this.cart=await this.adapter.refresh();this.message=this.cart.discount_codes?.some(d=>d.code.toUpperCase()===code && d.applicable)?`${code} applied.`:'That code is not available for this cart.'; }
      });
    }
    async choose(id) {
      if(!config.variants.some(v=>String(v.id)===String(id)&&v.available)) return;
      await this.run(async()=>{
        this.cart=await this.adapter.get();
        if(!BootyRules.inspect(this.cart,config).qualifies) {this.message='Your cart no longer qualifies. Add a little more to choose your bag.';return;}
        await this.removeGifts(this.cart,'');
        try {
          await this.adapter.add(id);
          this.cart=await this.adapter.update({discount:'BOOTY'});
          this.cart=await this.adapter.get();
          if(!BootyRules.inspect(this.cart,config).validGift) throw new Error('We could not confirm your free bag. It has been removed so you will not be charged for it.');
          this.intent=true;this.conflict=null;this.message='Your free Boo-Ty Bag is in your cart. BOOTY is your only discount.';
        } catch(error) {
          // Roll back the gift if Shopify did not actually allocate the expected discount.
          const fresh=await this.adapter.get();await this.removeGifts(fresh,'');this.cart=await this.adapter.refresh();throw error;
        }
        this.cart=await this.adapter.refresh();
      });
    }
    async cancel(otherCode='') {
      await this.run(async()=>{this.cart=await this.adapter.get();await this.removeGifts(this.cart,otherCode);this.cart=await this.adapter.refresh();this.intent=false;this.conflict=null;document.querySelectorAll('cart-discount input[name="discount"]').forEach(input=>{input.value=otherCode;});this.message=otherCode?'Bag removed. Your other code has been submitted.':'Your Boo-Ty Bag and code have been removed.';});
    }
    async reconcile(snapshot) {
      if(this.busy) {this.pending=true;return;}
      await this.run(async()=>{
        const revision=this.cartRevision||0;
        const fresh=snapshot||await this.adapter.get();
        if(revision!==(this.cartRevision||0)){this.pending=true;return;}
        this.cart=fresh;const state=BootyRules.inspect(this.cart,config);
        if(state.gifts.length&&!state.validGift) {
          const remainingCodes=(this.cart.discount_codes||[]).filter(d=>d.applicable && BootyRules.normalize(d.code)!=='BOOTY').map(d=>d.code).join(',');
          await this.removeGifts(this.cart,remainingCodes);this.cart=await this.adapter.refresh();
          this.message=state.remaining?`Bag removed. Add ${money(state.remaining)} in merchandise to qualify again.`:'Bag removed because BOOTY is no longer eligible. You have not been charged for it.';
        } else if(state.validGift) this.intent=true;
        else if(state.qualifies && this.intent && this.message.startsWith('Bag removed. Add ')) this.message='Your cart qualifies again. Choose your free bag.';
      });
    }
    render() {
      if(this.cart && this.cart.items.length===0){this.intent=false;this.message='';this.conflict=null;}
      document.querySelectorAll('booty-picker, booty-tracker').forEach(el=>el.render(this));
      if(config.demo) renderDemo(this);
    }
  }
  class Picker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click',e=>{
        const button=e.target.closest('button');if(!button)return;
        e.stopPropagation();
        if(button.dataset.variant) controller.choose(button.dataset.variant);
        if(button.dataset.action==='cancel') controller.cancel();
        if(button.dataset.action==='switch') controller.cancel(controller.conflict);
        if(button.dataset.action==='keep') {controller.conflict=null;controller.message='Your free bag is selected.';controller.render();}
      });
      if(typeof controller!=='undefined') this.render(controller);
    }
    render(c) {
      const state=c.cart ? BootyRules.inspect(c.cart,config) : null;
      this.hidden=!c.cart?.items.length||(!c.intent&&!c.message&&!state?.gifts.length);
      if(this.hidden)return;
      this.innerHTML='<div class="booty-panel"><h3></h3><p class="booty-message" role="status" aria-live="polite"></p><div class="booty-choices"></div><div class="booty-actions"></div><small>No other discounts. Ends Monday, October 26th at 11:59 p.m. ET. While supplies last.</small></div>';
      this.querySelector('h3').textContent=state?.validGift?'Your Boo-Ty Bag is free':'Choose your free Boo-Ty Bag';
      let message=c.message;
      if(!state?.active) message='This offer is not currently available.';
      else if(!state.currencyOK) message='This offer is available in USD only.';
      else if(state.remaining) message=`${c.message.startsWith('Bag removed')?'Bag removed. ':''}Add ${money(state.remaining)} in merchandise to choose your free bag.`;
      this.querySelector('.booty-message').textContent=c.busy?'Updating your cart…':message||'A free $129 mystery bag for her or for couples.';
      if(state?.qualifies && c.intent && !c.conflict) {
        for(const variant of config.variants) {
          const button=document.createElement('button');button.type='button';button.className='booty-choice';button.dataset.variant=variant.id;
          button.disabled=c.busy||!variant.available;button.setAttribute('aria-pressed',String(state.gifts.some(i=>String(i.variant_id)===String(variant.id))));
          const img=document.createElement('img');img.src=variant.image;img.alt=variant.alt;img.width=400;img.height=400;
          const title=document.createElement('strong');title.textContent=variant.label;
          const label=document.createElement('span');label.className='booty-choice-price';
          if(variant.available){const price=document.createElement('s');price.textContent='$129';const free=document.createElement('b');free.textContent=state.gifts.some(i=>String(i.variant_id)===String(variant.id))?'FREE ✓':'FREE';label.append(price,document.createTextNode(' '),free);}else label.textContent='Sold out';
          button.append(img,title,label);this.querySelector('.booty-choices').append(button);
        }
      }
      const actions=this.querySelector('.booty-actions');
      const action=(label,name)=>{const b=document.createElement('button');b.type='button';b.className='booty-cancel';b.textContent=label;b.dataset.action=name;b.disabled=c.busy;actions.append(b);};
      if(c.conflict){action('Keep my free bag','keep');action('Remove bag and use other code','switch');}
      else if(state?.gifts.length)action('Remove free bag','cancel');
      else if(c.intent)action('Continue without the offer','cancel');
      this.setAttribute('aria-busy',String(c.busy));
    }
  }
  class Tracker extends HTMLElement {
    connectedCallback() {
      this.innerHTML='<div class="booty-reward-heading"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13M12 8H7a3 3 0 1 1 3-3l2 3Zm0 0h5a3 3 0 1 0-3-3l-2 3Z"/></svg><strong>Boo-Ty Bag</strong><span class="booty-reward-badge" hidden>Bag added ✓</span></div><div class="booty-tracker-copy" role="status" aria-live="polite"></div><p class="booty-tracker-value">Spend $129, get a free mystery bag worth $129.</p><div class="booty-tracker-progress" role="progressbar" aria-label="Progress toward free Boo-Ty Bag" aria-valuemin="0" aria-valuemax="129"><span></span></div><button type="button" class="booty-tracker-claim">Choose my bag</button>';
      this.querySelector('button').addEventListener('click',async e=>{
        e.preventDefault();e.stopPropagation();
        controller.intent=true;controller.message='Checking your cart…';
        mount();const applying=controller.apply('BOOTY');revealPicker();await applying;revealPicker();
      });
      this.render(controller);
    }
    render(c) {
      const state=c.cart?BootyRules.inspect(c.cart,config):null;
      const available=config.variants.some(v=>v.available);
      this.hidden=!state?.active||!state.currencyOK||!available||!c.cart.items.length;
      const header=this.closest('.mini-cart__header');
      header?.classList.toggle('booty-campaign-active',!this.hidden);
      header?.classList.toggle('booty-gift-added',!!state?.validGift);
      if(this.hidden)return;
      this.querySelector('.booty-tracker-copy').textContent=state.qualifies?'Your free bag is ready to choose ✓':`Your free mystery bag is only ${money(state.remaining)} away.`;
      this.querySelector('.booty-tracker-copy').hidden=state.validGift;
      this.querySelector('.booty-reward-badge').hidden=!state.validGift;
      this.classList.toggle('is-earned',state.validGift);
      const bar=this.querySelector('[role="progressbar"]');
      bar.setAttribute('aria-valuenow',String(Math.min(state.subtotal,config.minimum)/100));
      bar.setAttribute('aria-valuetext',state.qualifies?'$129 merchandise minimum reached':`${money(state.subtotal)} of $129 in merchandise`);
      bar.querySelector('span').style.width=`${Math.min(100,state.subtotal/config.minimum*100)}%`;
      bar.hidden=false;
      this.querySelector('.booty-tracker-value').hidden=false;
      const button=this.querySelector('button');button.hidden=!state.qualifies;button.disabled=c.busy;
      button.textContent=state.validGift?'Change my bag':'Choose my bag';
    }
  }
  function cartSnapshot(root) {
    const node=root.querySelector('[data-booty-cart-snapshot]');
    if(!node)return null;
    try{
      const cart=JSON.parse(node.textContent);
      if(!Array.isArray(cart.items)||typeof cart.total_price!=='number')return null;
      // Liquid cart JSON omits discount_codes; recover applied codes from allocations.
      const applications=[...(cart.cart_level_discount_applications||[]),...cart.items.flatMap(i=>(i.line_level_discount_allocations||[]).map(a=>a.discount_application))];
      cart.discount_codes=cart.discount_codes||[...new Set(applications.filter(a=>a.type==='discount_code').map(a=>a.title))].map(code=>({code,applicable:true}));
      return cart;
    }catch{return null;}
  }
  const controller=new Controller(config.demo?new DemoCart():new ShopifyCart());
  if(!config.demo)controller.cart=cartSnapshot(document);
  customElements.define('booty-picker',Picker);
  customElements.define('booty-tracker',Tracker);
  function mount() {
    if(!config.demo) {
      const header=document.querySelector('#mini-cart .mini-cart__header');
      if(header&&!document.querySelector('#mini-cart booty-tracker')) {
        const tracker=document.createElement('booty-tracker');
        const shipping=header.querySelector('.free-shipping');
        if(shipping)shipping.before(tracker);else header.querySelector('#mini-cart-title')?.after(tracker);
      }
      const drawer=document.querySelector('#mini-cart');
      const main=drawer?.querySelector('.mini-cart__main');
      if(header&&main){
        let rewards=main.querySelector('.booty-scroll-rewards');
        const tracker=drawer.querySelector('booty-tracker');
        const shipping=drawer.querySelector('.free-shipping');
        if(!rewards){rewards=document.createElement('div');rewards.className='booty-scroll-rewards';main.prepend(rewards);}
        if(tracker&&tracker.parentElement!==rewards)rewards.append(tracker);
        if(shipping&&shipping.parentElement!==rewards)rewards.append(shipping);
      }
      const pageItems=document.querySelector('main #main-cart-items');
      if(pageItems&&!document.querySelector('main booty-tracker'))pageItems.before(document.createElement('booty-tracker'));
    }
    document.querySelectorAll('cart-discount').forEach(el=>{
      const drawer=el.closest('#mini-cart');
      const target=drawer?.querySelector('cart-items');
      if(target) {if(!target.querySelector('booty-picker'))target.append(document.createElement('booty-picker'));}
      else if(!el.parentElement.querySelector('booty-picker'))el.insertAdjacentElement('afterend',document.createElement('booty-picker'));
    });
    controller.render();
  }
  function revealPicker(input) {
    mount();
    const disclosure=input?.closest('details');
    if(disclosure?.open)disclosure.querySelector('summary')?.click();
    const picker=document.querySelector('#mini-cart booty-picker')||document.querySelector('booty-picker');
    picker?.scrollIntoView({block:'start',behavior:'smooth'});
  }
  async function showOffer(input) {
    const code=BootyRules.normalize(input.value);
    if(code==='BOOTY') {controller.intent=true;controller.message='Checking your cart…';}
    // A product add can replace cart-items while leaving the discount form intact.
    mount();
    const applying=controller.apply(code);
    revealPicker(input);
    await applying;
    revealPicker(input);
  }
  document.addEventListener('click',e=>{
    const apply=e.target.closest('[data-discount-btn]');
    if(apply) {
      const input=apply.closest('cart-discount')?.querySelector('input[name="discount"]');
      if(input && (BootyRules.normalize(input.value)==='BOOTY'||controller.intent||BootyRules.inspect(controller.cart||{items:[],currency:'USD'},config).gifts.length)) {
        e.preventDefault();e.stopImmediatePropagation();showOffer(input);
      }
    }
    const remove=e.target.closest('[is="discount-remove"]');
    if(remove&&BootyRules.normalize(remove.dataset.discount)==='BOOTY') {e.preventDefault();e.stopImmediatePropagation();controller.cancel();}
  },true);
  document.addEventListener('keydown',e=>{
    if(e.key==='Enter'&&e.target.matches('cart-discount input[name="discount"]')&&BootyRules.normalize(e.target.value)==='BOOTY'){e.preventDefault();e.stopImmediatePropagation();showOffer(e.target);}
  },true);
  // Recheck before standard checkout. This does not claim to protect direct/accelerated checkout bypasses.
  document.addEventListener('submit',async e=>{
    if(config.demo||!e.submitter?.matches('[name="checkout"]'))return;
    const form=e.target,button=e.submitter;
    if(form.dataset.bootyChecked==='yes'){delete form.dataset.bootyChecked;return;}
    e.preventDefault();e.stopImmediatePropagation();
    if(controller.busy)return;
    try {
      const cart=await controller.adapter.get(),state=BootyRules.inspect(cart,config);
      if(state.gifts.length&&!state.validGift){await controller.reconcile();return;}
      const enteredBooty=[...form.querySelectorAll('[name="discount"]')].some(input=>BootyRules.normalize(input.value)==='BOOTY');
      if(state.qualifies&&!state.gifts.length&&(controller.intent||enteredBooty)) {
        controller.cart=cart;controller.intent=true;controller.message='Choose your free bag before checking out, or continue without the offer.';
        revealPicker(form.querySelector('cart-discount input'));return;
      }
      // Prevent a stale hidden discount input from re-applying a removed wheel code.
      if(state.validGift)form.querySelectorAll('[name="discount"]').forEach(input=>input.value='BOOTY');
      form.dataset.bootyChecked='yes';form.requestSubmit(button);
    }catch{controller.message='Please refresh your cart before checking out. We could not verify your gift.';controller.render();}
  },true);
  if(!config.demo) {
    mount();
    new MutationObserver(records=>{if(records.some(r=>(r.target.matches?.('cart-items')&&!r.target.querySelector('booty-picker'))||[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('cart-discount')||n.querySelector?.('cart-discount')))))mount();}).observe(document.body,{childList:true,subtree:true});
    // Native adds publish cart-update but do not always dispatch cart:updated.
    // Quantity responses contain the complete cart; use them without another GET.
    const seenCarts=new WeakSet();
    const receiveCart=event=>{
      let cart=event?.cart;
      if(cart?.sections?.['mini-cart']){const snapshot=cartSnapshot(new DOMParser().parseFromString(cart.sections['mini-cart'],'text/html'));if(snapshot)cart=snapshot;}
      if(cart&&typeof cart==='object'){
        if(seenCarts.has(cart))return;
        seenCarts.add(cart);
      }
      if(event?.source==='booty-picker')return;
      controller.cartRevision=(controller.cartRevision||0)+1;
      const complete=cart&&Array.isArray(cart.items)&&typeof cart.total_price==='number'&&typeof cart.item_count==='number';
      if(complete){controller.cart=cart;mount();}
      // Add responses contain only added items. Fetch the complete cart immediately.
      controller.reconcile(complete?cart:undefined);
    };
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,receiveCart);
    document.addEventListener('cart:updated',event=>receiveCart(event.detail));
    document.addEventListener('cartdrawer:opened',mount);
    window.matchMedia('(max-width: 749px)').addEventListener('change',mount);
    window.addEventListener('pageshow',()=>controller.reconcile());
    window.addEventListener('focus',()=>controller.reconcile());
  }
  function renderDemo(c) {
    if(!c.cart)return;
    const state=BootyRules.inspect(c.cart,config);
    document.querySelector('[data-demo-subtotal]').textContent=money(state.subtotal);
    document.querySelector('[data-demo-total]').textContent=money(c.cart.items.reduce((s,i)=>s+i.final_line_price,0));
    document.querySelector('[data-demo-code]').textContent=c.cart.discount_codes.filter(d=>d.applicable).map(d=>d.code).join(', ')||'None';
    const line=document.querySelector('[data-demo-gift]');line.hidden=!state.gifts.length;
    line.textContent=state.gifts.length?`${config.variants.find(v=>String(v.id)===String(state.gifts[0].variant_id)).label} Boo-Ty Bag — ${state.validGift?'FREE':money(state.gifts[0].final_line_price)}`:'';
    document.querySelectorAll('[data-demo-amount],[data-demo-wheel],[data-demo-expire]').forEach(b=>b.disabled=c.busy);
  }
  if(config.demo) {
    document.querySelector('[data-demo-apply]').addEventListener('click',async()=>{await controller.apply(document.querySelector('[data-demo-input]').value);const disclosure=document.querySelector('[data-demo-disclosure]');if(disclosure)disclosure.open=false;});
    document.querySelector('[data-demo-input]').addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();showOffer(e.target);}});
    document.querySelectorAll('[data-demo-amount]').forEach(b=>b.addEventListener('click',()=>{controller.adapter.setSubtotal(Number(b.dataset.demoAmount));controller.reconcile();}));
    document.querySelector('[data-demo-wheel]').addEventListener('click',()=>controller.apply('SPINNYWHEEL10'));
    document.querySelector('[data-demo-expire]').addEventListener('click',()=>{config.endsAt='2000-01-01T00:00:00Z';controller.reconcile();});
  }
  controller.reconcile();
})();
